import {
  FilterType,
  SpaceEntity,
  SpaceFilter,
} from "modules/spaces/domain/space/space.types";

export const SPACES_MOCK: Partial<SpaceEntity>[] = [
  {
    id: "61c4713562720c64f06dcbe1",
    name: "Single room",
    address: "Medardo Rosso, 5",
    price: 700,
    tags: [],
    maxGuestsNumber: 3,
    currentGuests: [],
    bathroom: "shared",
    floor: 6,
    affinity: null,
    images: [
      "https://images.unsplash.com/photo-1556912167-f556f1f39fdf?q=80&w=3581&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?q=80&w=3553&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      "https://images.unsplash.com/photo-1616486338812-3dadae4b4ace?q=80&w=3732&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    ],
    firstAvailability: "2023-08-08T07:42:11.696+00:00",
    features: [],
    accessibility: [],
    rules: [],
    buildingServices: [],
  },
  {
    id: "61c4713562720c64f06dcbe1",
    name: "Double room",
    maxGuestsNumber: 4,
    bathroom: "shared",
    currentGuests: [],
    tags: [],
    floor: 3,
    affinity: 80,
    images: [
      "https://images.unsplash.com/photo-1507089947368-19c1da9775ae?q=80&w=3576&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      "https://images.unsplash.com/photo-1611216212569-d739dbe9ed40?q=80&w=3731&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      "https://images.unsplash.com/photo-1616486338812-3dadae4b4ace?q=80&w=3732&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    ],
    firstAvailability: "2023-10-22T07:42:11.696+00:00",
    features: [],
    accessibility: [],
    rules: [],
    buildingServices: [],
  },
  {
    id: "61c4713562720c64f06dcbe1",
    name: "Triple room",
    bathroom: "shared",
    maxGuestsNumber: 6,
    tags: [],
    currentGuests: [
      { type: "night-owls", interests: ["musician", "veggie"] },
      { type: "night-owls", interests: ["globe-trotters", "veggie"] },
      { type: "early-birds", interests: ["globe-trotters"] },
    ],
    floor: 7,
    affinity: null,
    images: [
      "https://images.unsplash.com/photo-1623298371642-416fcc1286d0?q=80&w=3571&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    ],
    firstAvailability: "2023-12-12T07:42:11.696+00:00",
    features: [],
    accessibility: [],
    rules: [],
    buildingServices: [],
  },
];

export const SPACE_FILTERS_MOCK: SpaceFilter[] = [
  {
    name: "accommodation",
    options: ["single", "studio"],
    type: FilterType.Checkbox,
    isMultiChoice: false,
  },
  {
    name: "bathroom",
    options: ["private"],
    type: FilterType.Toggle,
    isMultiChoice: false,
  },
  {
    name: "housemates",
    options: ["any", "many", "more"],
    type: FilterType.Radio,
    isMultiChoice: false,
  },
  {
    name: "floor",
    options: ["any", "0", "1", "2", "3", "4", "5"],
    type: FilterType.Radio,
    isMultiChoice: true,
  },
];
